export const roles = {
  ROLE_ADMIN_FINANCE: "ROLE_ADMIN_FINANCE",
  ROLE_STUDENT_BUDDY: "ROLE_STUDENT_BUDDY",
  ROLE_SUPER_ADMIN: "SUPER_ADMIN",

  // Quotation module — mirrors the roles order-service gates on.
  ROLE_QUOTATION_CREATE: "ROLE_QUOTATION_CREATE",
  ROLE_QUOTATION_APPROVE: "ROLE_QUOTATION_APPROVE",
  ROLE_QUOTATION_VIEW: "ROLE_QUOTATION_VIEW",

  // Purchase Order module — mirrors the roles order-service gates on.
  // MANAGER is Sales Ops, CREATE is the Sales Agent (PO_Technical_Spec §2).
  ROLE_PO_MANAGER: "ROLE_PO_MANAGER",
  ROLE_PO_CREATE: "ROLE_PO_CREATE",
  ROLE_PO_FINANCE: "ROLE_PO_FINANCE",
  ROLE_PO_VIEW: "ROLE_PO_VIEW",

  // Refunds module (KnowledgeHut) — mirrors the roles application-service
  // gates on. Finance also accepts ROLE_ADMIN_FINANCE (above).
  ROLE_REFUND_CREATE: "ROLE_REFUND_CREATE",
  ROLE_REFUND_COMMITTEE: "ROLE_REFUND_COMMITTEE",
  ROLE_REFUND_PROCESS: "ROLE_REFUND_PROCESS",
  ROLE_REFUND_REPORT: "ROLE_REFUND_REPORT",
  ROLE_FINANCE_REFUND_APPROVAL: "ROLE_FINANCE_REFUND_APPROVAL",
};
